import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var modal = {
    selector: '.modal',
    init: function() {
        var self = this,
        $modal = $( self.selector );


        $('[data-modal-open]').on('click', function() {
            disableBodyScroll( modal, { reserveScrollBarGap: true } );
            $('.modal').css("display", "flex").hide().fadeIn();
        });
        
        $('[data-modal-close]').on('click', function() {
            $('.modal').fadeOut();
            enableBodyScroll( modal );
        });

    },
}

export {
    modal
};
